<template>
    <div class="d-lg-none">

        <div v-if="loading">
            <div class="card bg-info mt-4">
                <loading-animation/>
                Please wait while loading data from the server.
            </div>
        </div>

        <div v-else-if="error">
            <div class="card bg-danger mt-4">
                <error-icon/>
                Failed to load data from the server.
            </div>
        </div>

        <div v-else>
            <div v-for="(i, k) in details.data" v-bind:key="k" class="mt-2">
                <div class="mb-5">

                    <div class="gr-2-cols b-1 p-2">

                        <div class="fl-gr-1">
                            <div class="fl-x fl-j-c fl-a-c">
                                <div class="pos-r">
                                    <!--                                    <div class="line-right-1"></div>-->
                                    <span class="font-inter-medium">Sl No</span>
                                </div>
                            </div>
                        </div>

                        <div class="fl-gr-1">
                            <div class="fl-x fl-j-s fl-a-c">
                                <div class="pos-r text-left">
                                    <!--                                    <div class="line-right-1"></div>-->
                                    <span class="font-inter-medium">Membership Type</span>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="b-1 bs-3">
                        <div class="gr-2-cols font-inter-medium c-line-bottom p-3">

                            <div class="">
                                <div class="fl-x fl-j-c fl-a-c">
                                    <div class="pos-r">
                                        {{ i.sl_no }}
                                    </div>
                                </div>
                            </div>

                            <div class="">
                                <div class="pos-r">
                                    <div class="line-right-1"></div>
                                    {{ i.membership_type }}
                                </div>
                            </div>

                        </div>

                        <div class="row b-1 fs--1 m-0">

                            <span class="b-1 w-100 col-6 p-2">
                            <div class="p-1">
                               <span class="font-inter-medium">User : </span> <br> <span class="ml-2">{{
                                    i.user_name
                                }}</span>
                            </div>
                        </span>

                            <span class="b-1 w-100 col-6 p-2">
                            <div class="p-1">
                               <span class="font-inter-medium">Trn ID : </span> <br> <span class="ml-2">{{
                                    i.txn_id
                                }}</span>
                            </div>
                        </span>

                            <span class="b-1 w-100 col-6 p-2">
                            <div class="p-1">
                               <span class="font-inter-medium">Payment Status :</span> <span class="">
                                {{ i.payment_status }}
                            </span>
                            </div>
                        </span>

                            <span class="b-1 w-100 col-12 p-2">
                            <div class="p-1">
                                <span class="font-inter-medium">Trn Date :</span><br>
                                <span class="ml-2"> {{ i.date_time }} </span>
                            </div>
                        </span>
                            <span class="b-1 w-100 col-12 p-2">
                            <div class="p-1">
                                <span class="font-inter-medium">Trn Initiated Date :</span><br>
                                <span class="ml-2"> {{ i.created_date }} </span>
                             </div>
                        </span>
                            <span class="b-1 col-12">
                    <div class="p-1 fl-x fl-j-c py-3">
                        <edit-btn @click="viewDetails(i.txn_id)" size="sm" class="px-4" icon="" text="Details"/>
                    </div>
                </span>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="details.data.length !== 0" class="mt-3 fl-te-c-res">
                <div class="mb-2">
                    Showing {{ details.from }} to {{ details.to }} of {{ details.total }} entries
                </div>
                <div>
                    <btn class="m-1" size="sm" @click="prevClicked" v-if="prev" type="button"
                         icon="fa fa-chevron-left"/>
                    <btn class="m-1" size="sm" disabled v-else type="button" icon="fa fa-chevron-left"/>
                    <btn class="m-1" size="sm" type="button">{{ details.current_page }}</btn>
                    <btn class="m-1" size="sm" @click="nextClicked" v-if="next" type="button"
                         icon="fa fa-chevron-right"/>
                    <btn class="m-1" size="sm" disabled v-else type="button" icon="fa fa-chevron-right"/>
                </div>
            </div>

            <div v-if="details.data.length === 0" class="card">
                <div class="mb-2">
                    <div>
                        <div class="fl-x fl-j-c fl-a-c">
                            No Data
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'secure-axios';
import urls from '../../data/urls';
import _ from 'lodash';

export default {
    name : 'TransactionMobileView',

    props : {
        ext_search : {
            type : String
        }
    },

    data () {
        return {
            prev     : '',
            next     : '',
            page     : '1',
            per_page : '10',
            loading  : true,
            error    : false,
            details  : null
        };
    },

    computed : {
        ...mapGetters(['currentUser'])
    },

    watch : {
        ext_search () {
            this.timeOutLoadData();
        }
    },

    mounted () {
        this.loadData();
    },

    methods : {
        timeOutLoadData : _.debounce(function () {
            this.loadData();
        }, 2000),
        viewDetails (item) {
            this.$router.push('/transactions/' + item + '/details/');
        },
        loadData () {
            const that = this;

            that.loading = true;
            that.error = false;

            axios.get(urls.transactions.listUrl, {
                params : {
                    page       : that.page,
                    per_page   : that.per_page,
                    ext_search : this.ext_search
                }
            }).then(function (response) {
                const json = response.data;
                that.details = { ...json };
                that.setPagination();
                that.loading = false;
                that.error = false;
            }).catch(function (exception) {
                console.log('exception : ', exception);
                that.loading = false;
                that.error = true;
            });
        },
        setPagination () {
            this.prev = parseInt(this.details.current_page) !== this.details.from;
            this.next = parseInt(this.details.current_page) !== this.details.last_page;
        },
        prevClicked () {
            this.page = parseInt(this.page) - 1;
            this.loadData();
        },
        nextClicked () {
            this.page = parseInt(this.page) + 1;
            this.loadData();
        }

    }
};
</script>

<style scoped>

</style>
